import { Component, Inject } from '@angular/core';
import { helper } from 'src/environments/helper';
import { Beneficiar } from '../../../beneficiari.interface';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BeneficiariService } from '../../../beneficiari.service';
import { CommonService } from 'src/app/services/common.service';
import { NotificationService } from 'src/app/services/notification.service';
import Swal from 'sweetalert2';
import { finalize } from 'rxjs';
// import { countriesList, ICountryOption } from 'src/app/shared/countries-list';

// import { PhoneNumberUtil } from 'google-libphonenumber'
// const phoneNumberUtil = PhoneNumberUtil.getInstance();

@Component({
    selector: 'app-edit-subsemnat',
    templateUrl: './edit-subsemnat.component.html',
    styleUrls: ['./edit-subsemnat.component.scss']
})
export class EditSubsemnatComponent {
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;

    successTitle: string = helper.dialogConfig.headers.success;
    successIcon: string = helper.dialogConfig.icons.success;
    successType: string = helper.dialogConfig.icons.success;
    helper = helper;

    isLoading = false;

    beneficiarData: Beneficiar | null = null;

    public maxDate: Date = new Date();

    // phone
    // optionRom: ICountryOption = {
    //     name: 'Romania',
    //     flag: '🇷🇴',
    //     code: 'RO',
    //     dial_code: '+40',
    // };

    // currentOption = this.optionRom;
    // options: ICountryOption[] = countriesList;

    // changeCountry(option: ICountryOption) {
    //     this.currentOption = option;
    // }

    form: FormGroup = new FormGroup({
        last_name: new FormControl('', [Validators.required]),
        first_name: new FormControl('', [Validators.required]),
        birth_date: new FormControl('', [Validators.required]),
        cnp: new FormControl('', [Validators.pattern('[0-9]{13}')]),
        telefon: new FormControl('', [Validators.pattern(/^(\+4)?\d{10}$/)]),
        email: new FormControl('', [Validators.email]),
        observatii: new FormControl('', [Validators.maxLength(500)]),
    });

    // Validator pentru nume complet (minim 2 cuvinte)
    numeCompletValidator(control: FormControl): { [key: string]: boolean } | null {
        if (!control.value) return null;
        const parts = control.value.trim().split(/\s+/);
        if (parts.length < 2) {
            return { 'minWords': true };
        }
        return null;
    }

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            beneficiarData: Beneficiar,
        },
        private dialogRef: MatDialogRef<EditSubsemnatComponent>,
        private beneficiariService: BeneficiariService,
        private notificationService: NotificationService,
    ) {
        this.beneficiarData = data.beneficiarData;
    }

    ngOnInit() {
        if (this.beneficiarData) {
            this.form.controls['last_name'].patchValue(this.beneficiarData.last_name);
            this.form.controls['first_name'].patchValue(this.beneficiarData.first_name);
            this.form.controls['birth_date'].patchValue(this.beneficiarData.birth_date);
            this.form.controls['cnp'].patchValue(this.beneficiarData.cnp);
            this.form.controls['telefon'].patchValue(this.beneficiarData.phone);
            this.form.controls['email'].patchValue(this.beneficiarData.email);
            this.form.controls['observatii'].patchValue(this.beneficiarData.notes || '');

            // if (this.beneficiarData.iso_code) {
            //     const countryOption = countriesList.find(
            //         (c: any) => c.code.toLowerCase() == this.beneficiarData?.iso_code.toLowerCase()
            //     );
            //     this.currentOption = countryOption ? countryOption : this.optionRom;
            // }
        }
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    formatDate(date: Date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }

    submitForm() {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'Vă rugăm să confirmați acest proces!',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.updateInfo();
            }
        });
    }

    updateInfo() {
        this.isLoading = true;

        // let phone;

        // const telephoneNoInput = this.currentOption.dial_code + this.form.value.telefon;

        // const phoneNo = phoneNumberUtil.parseAndKeepRawInput(telephoneNoInput);
        // let regionCodeLower = '';
        // let nationalNumberString = '';

        // if (phoneNo) {
        //     const regionCode = phoneNumberUtil.getRegionCodeForNumber(phoneNo);
        //     if (regionCode) {
        //         regionCodeLower = (regionCode as string).toLowerCase();
        //     }

        //     const nationalNumber = phoneNo.getNationalNumber();
        //     if (nationalNumber) {
        //         nationalNumberString = nationalNumber.toString();
        //     }
        // }

        // phone = {
        //     dialCode: '',
        //     internationalNumber: telephoneNoInput,
        //     isoCode: regionCodeLower,
        //     nationalNumber: nationalNumberString,
        // };

        // phone.dialCode = telephoneNoInput.replace(phone.nationalNumber, '');
        // phone.nationalNumber = phone.isoCode == 'ro' ? '0' + phone.nationalNumber : phone.nationalNumber;

        const payload = {
            id: this.beneficiarData!.id,
            last_name: this.form.value.last_name,
            first_name: this.form.value.first_name,
            birth_date: this.form.value.birth_date ? this.formatDate(this.form.value.birth_date) : '',
            cnp: this.form.value.cnp,
            telefon: this.form.value.telefon,
            email: this.form.value.email,
            observatii: this.form.value.observatii || null,
            // phone: phone,
        }

        this.beneficiariService
            .updateBeneficiar(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    Swal.fire({
                        title: helper.dialogConfig.headers.success,
                        text: 'Datele de identificare au fost actualizate cu succes',
                        icon: 'success',
                        confirmButtonText: this.helper.dialogConfig.buttonLabels.close,
                        allowOutsideClick: false,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.dialogRef.close({ success: true });
                        }
                    });
                },
                error: (err) => {
                    let msg;
                    try {
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
